import { createSlice } from "@reduxjs/toolkit";
import {
    fetchCourseModulesTableColumnNames,
    fetchAllCourseModules,
    createCourseModules,
    updateCourseModules,
    deleteCourseModules,
    activateDeactivateCoursesModule
} from "./thunk";

const courseModulesSlice = createSlice({
  name: "modules",
  initialState: {
    course: {},
    modules: [],
    tableColumnNames: [],
    loading: false,
    loadings: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder

    // Fetch Course Modules Table Column Names
    .addCase(fetchCourseModulesTableColumnNames.pending, (state) => {
      state.loadings = true;
      state.error = null;
    })
    .addCase(fetchCourseModulesTableColumnNames.fulfilled, (state, action) => {
      state.loadings = false;
      state.tableColumnNames = action.payload;
    })
    .addCase(fetchCourseModulesTableColumnNames.rejected, (state, action) => {
      state.loadings = false;
      state.error = action.payload;
    })

    // Get All Course Modules
    .addCase(fetchAllCourseModules.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.course = {};
      state.modules = [];
    })
    .addCase(fetchAllCourseModules.fulfilled, (state, action) => {
      const { Modules, ...Course } = action.payload;
      state.loading = false;
      state.course = Course;
      state.modules = Modules;
    })
    .addCase(fetchAllCourseModules.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    // Add Course Modules
    .addCase(createCourseModules.pending, (state) => {
      state.error = null;
    })
    .addCase(createCourseModules.fulfilled, (state, action) => {
      state.modules = [action.payload.data[0], ...state.modules];
      // toast.success(action.payload.message);
    })
    .addCase(createCourseModules.rejected, (state, action) => {
      state.error = action.payload;
    })

    // Update Course Modules
    .addCase(updateCourseModules.pending, (state) => {
      state.error = null;
    })
    .addCase(updateCourseModules.fulfilled, (state, action) => {
      const index = state.modules.findIndex(
        (item) => item.ID === action.payload[0].ID
      );

      if (index >= 0) {
        state.modules[index] = action.payload[0];
        // toast.success("Updated successfully");
      }
    })
    .addCase(updateCourseModules.rejected, (state, action) => {
      state.error = action.payload;
    })

    // Delete Course
    .addCase(deleteCourseModules.pending, (state) => {
      state.error = null;
    })
    .addCase(deleteCourseModules.fulfilled, (state, action) => {
      const deletedIds = action.payload.map((item) => item.ID);

      // Filter out the deleted items
      state.modules = state.modules.filter((item) => !deletedIds.includes(item.ID));
    })
    .addCase(deleteCourseModules.rejected, (state, action) => {
      state.error = action.payload;
    })

    // Active Deactive Course
    .addCase(activateDeactivateCoursesModule.pending, (state) => {
      state.error = null;
    })
    .addCase(activateDeactivateCoursesModule.fulfilled, (state, action) => {
      if (action.payload) {
        const updatedCourse = action.payload[0] || {};

        state.modules = state.modules.map((item) => item.ID === updatedCourse.ID ? {...item, IsActive: updatedCourse.IsActive} : item)
      }
    })
    .addCase(activateDeactivateCoursesModule.rejected, (state, action) => {
      state.error = action.payload;
    })
  },
});

export default courseModulesSlice.reducer;
